import { createReducer, MetaReducer, on } from '@ngrx/store';
import { IEventLog } from '../../../../model/event-logs';
import EventLogsActions from './event-logs.action-types';
export const eventLogsFeatureKey = 'eventLogs';

export interface EventLogsState {
    eventLogs: IEventLog[];
}

export const initialEventLogsState: EventLogsState = {
    eventLogs: []
};

export const metaReducers: MetaReducer<EventLogsState>[] = [];

export const eventLogsContextReducer = createReducer(
    initialEventLogsState,

    on(EventLogsActions.loadEventLogs, (state, action) => {
        return {
            eventLogs: action.eventLogs
        };
    })
);
